import { Link } from '@chakra-ui/react';
import { ComponentProps, FC } from 'react';

const EnlaceIcono: FC<ComponentProps<typeof Link>> = ({
  children,
  ...props
}) => {
  return <Link {...props}>{children}</Link>;
};

export default EnlaceIcono;
